import type { MouseEvent, ReactNode } from 'react';

import { cn } from '../cn';
import { General, Shapes } from '../StrokeIcons';
import IconButton from './IconButton';
import type { Size } from './types';

export type CheckboxIconButtonProps = {
  checked: boolean;
  indeterminate?: boolean;
  somethingChecked?: boolean;
  onClick: (e: MouseEvent<HTMLButtonElement>) => void;
  className?: string;
  size?: Size;
  tooltip?: ReactNode;
};

export default function CheckboxIconButton({
  checked,
  indeterminate,
  somethingChecked,
  onClick,
  className,
  size = 'xs',
  tooltip,
}: CheckboxIconButtonProps) {
  const isOn = checked || indeterminate;
  const icon = indeterminate ? (
    <General.MinusSquare />
  ) : checked ? (
    <General.CheckSquare />
  ) : (
    <Shapes.Square className="opacity-30" />
  );

  return (
    <IconButton
      size={size}
      tooltip={tooltip}
      className={cn(somethingChecked && 'opacity-100', className)}
      color={isOn ? 'blue' : 'gray'}
      tone={isOn ? 'soft' : 'filled'}
      icon={icon}
      onClick={(e) => {
        e.preventDefault();
        e.stopPropagation();
        onClick(e);
      }}
    />
  );
}
